(function() {

    var $scope = $('.module-articles .form-edit')

    if (!$scope.length) {
        return
    }

    $scope.on('click', '[data-toggle="tab"]', event => {
        const lang = event.target.dataset.lang

        if (!lang) {
            return
        }

        event.preventDefault()
        event.stopPropagation()

        const $tabs = $(`.is-visible [data-lang="${lang}"]`)
        $tabs.tab('show')
    })
})();